module.exports = __webpack_public_path__ + "static/food4-3ba1462bc6ab59f2de5d36def502f43d.jpg";